const storeData = (key, data) => {
  console.log(data, "storeData value==>", key);
  try {
    localStorage.setItem(key, data);
  } catch (e) {
    // console.log(e);
  }
};

const getData = async (key) => {
  try {
    const value = await localStorage.getItem(key);
    if (value !== null) {
      return value;
    }
  } catch (e) {
    // console.log(e);
  }
};

const clearAll = async (isFromWeb) => {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (!key.includes("Site_RefId_")) {
        localStorage.removeItem(key);
      }
    }
    console.log("cleared", localStorage);
  } catch (e) {
    console.error(e);
  }
};

const removeKeyData = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // console.log(e);
  }
};

export { storeData, getData, clearAll, removeKeyData };
